exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.result-image{background-position:50%;background-repeat:no-repeat;background-size:cover;border:1px solid #ebebeb;float:left;height:100px;margin:5px;min-width:100px;width:auto\n}\n.results-gallery{overflow-x:scroll\n}\n.results-gallery .close{margin:10px\n}", ""]);

// exports
